/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserClient_user_client_read } from '../models/UserClient_user_client_read';
import type { UserClient_user_client_write } from '../models/UserClient_user_client_write';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserClientService {
    /**
     * Retrieves the collection of UserClient resources.
     * Retrieves the collection of UserClient resources.
     * @param page The collection page number
     * @returns UserClient_user_client_read UserClient collection
     * @throws ApiError
     */
    public static apiV1UserClientsGetCollection(
        page: number = 1,
    ): CancelablePromise<Array<UserClient_user_client_read>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user_clients',
            query: {
                'page': page,
            },
            errors: {
                403: `Forbidden`,
            },
        });
    }
    /**
     * Creates a UserClient resource.
     * Creates a UserClient resource.
     * @param requestBody The new UserClient resource
     * @returns UserClient_user_client_read UserClient resource created
     * @throws ApiError
     */
    public static apiV1UserClientsPost(
        requestBody: UserClient_user_client_write,
    ): CancelablePromise<UserClient_user_client_read> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user_clients',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                403: `Forbidden`,
                422: `Unprocessable entity`,
            },
        });
    }
    /**
     * Retrieves a UserClient resource.
     * Retrieves a UserClient resource.
     * @param id UserClient identifier
     * @returns UserClient_user_client_read UserClient resource
     * @throws ApiError
     */
    public static apiV1UserClientsIdGet(
        id: string,
    ): CancelablePromise<UserClient_user_client_read> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user_clients/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Removes the UserClient resource.
     * Removes the UserClient resource.
     * @param id UserClient identifier
     * @returns void
     * @throws ApiError
     */
    public static apiV1UserClientsIdDelete(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/user_clients/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
}
